<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <slot />
    <g fill="none" fill-rule="evenodd" :stroke="color" transform="translate(.5 .5)">
      <path
        stroke-linejoin="round"
        d="M9.471 10.614c.628.249 1.312.386 2.029.386 3.038 0 5.5-2.462 5.5-5.5S14.538 0 11.5 0 6 2.462 6 5.5c0 .76.154 1.485.434 2.144L0 14v3h3l1-1v-2h2v-2h2l1.471-1.386z"
      />
      <circle cx="12.5" cy="4.5" r="1.5" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
